namespace Cfnc {
    "use strict";

    interface IStudentEnrichment {
    }

    interface IStudentEnrichmentScope extends ng.IScope {
        vm: StudentEnrichment;
    }

    class StudentEnrichment implements IStudentEnrichment {
        static $inject: Array<string> = ["common", "Restangular", "$scope"];
        static controllerId: string = "studentEnrichment";
        private log;
        pageNumber: number;
        pageSize: any;
        searchString: string;
        loaded: boolean;
        searchResults: any;
        cardView: boolean;
        minDate: Date;
        filterParams: any;
        interests: any;
        showMap: boolean;
        map: googleMaps.googleMap;
        options: any;
        stateCoords;
        mappingData;
        markers: Array<any>;
        selectedFilters: Array<any>;
        startDate: Date;
        endDate: Date;
        deadline: Date;
        interestOpen: boolean;
        gradeOpen: boolean;
        distanceOpen: boolean;
        dateOpen: boolean;
        overnightOpen: boolean;
        feeOpen: boolean;
        scholarOpen: boolean;
        hostOpen: boolean;
        feeRange: any;
        oldHost: any;
        oldDistance: any;
        oldSearch: any;
        apiHost: string;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showHowl?) => void;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: IStudentEnrichmentScope) {
            this.pageNumber = 1;
            this.pageSize = 25;
            this.cardView = true;
            this.searchString = "";
            this.oldHost = "";
            this.oldDistance = "";
            this.oldSearch = "";
            this.loaded = false;
            this.showMap = false;
            this.minDate = new Date(1899, 12);
            this.selectedFilters = [];
            this.markers = [];

            this.interests = ['Academic',
                'Academically Gifted',
                'Accounting',
                'Adventure',
                'Aerospace',
                'After School',
                'Agriculture',
                'Algebra',
                'Anthropology',
                'Apparel Design',
                'Archaeology',
                'Architecture',
                'Art',
                'Astronomy',
                'ADD/ADHD/LD',
                'Band',
                'Behavioral Science',
                'Biology',
                'Business',
                'Careers',
                'Challenge',
                'Chemistry',
                'Choir',
                'College Courses',
                'College Preparation',
                'Communications',
                'Computers',
                'Cosmetology',
                'Creative',
                'Culinary',
                'Culture',
                'CPR',
                'Dance',
                'Debate',
                'Design',
                'Disadvantaged',
                'Diversity',
                'Economics',
                'Engineering',
                'Enrichment',
                'Entomology',
                'Environment',
                'ESL',
                'Fine Arts',
                'First Generation College Student',
                'Geology',
                'Geometry',
                'Graphic Design',
                'Health',
                'History',
                'Humanities',
                'Internships',
                'Leadership',
                'Literacy',
                'Literature',
                'Low Income',
                'Marine Biology',
                'Math',
                'Mechanics',
                'Media',
                'Medical/Medicine',
                'Minorities',
                'Music',
                'North Carolina',
                'Nuclear',
                'Oceanography',
                'Orchestra',
                'Performing Arts',
                'Pharmacy',
                'Philosophy',
                'Physics',
                'Piano',
                'Problem Solving',
                'Programming',
                'Psychology',
                'Research',
                'Robotics',
                'Science',
                'Service Learning',
                'Social Science',
                'Sports',
                'String Instruments',
                'Teaching',
                'Teamwork',
                'Technology',
                'Test Preparation',
                'Textiles',
                'Transportation',
                'Tutoring',
                'Volunteering',
                'Web Design',
                'Writing',
                'Youth',
                '4-H'];
            this.log = common.logger.getLogFn(StudentEnrichment.controllerId);
            this.logSuccess = this.common.logger.getLogFn(StudentEnrichment.controllerId, "success");
            this.logError = common.logger.getLogFn(StudentEnrichment.controllerId, "error");

            this.map = { center: { latitude: 35.250224, longitude: -79.905000 }, zoom: 7, pan: true };
            this.options = { options: { mapTypeId: google.maps.MapTypeId.TERRAIN, streetViewControl: false, zoomControlOptions: { style: google.maps.ZoomControlStyle.SMALL } } };
            this.stateCoords = coords;
            //this.common.authentication.authenticate(true).then(result => {
            //    if (result) {
            //        this.activate();
            //    }
            //});
            this.activate();

        }

        activate() {
            var promises = [];
            this.common.activateController(promises, StudentEnrichment.controllerId)
                .then(() => {
                    var config = new Config();
                    this.apiHost = config.apiHost;
                    this.buildFilterObject();
                    this.getAllPrograms();
                });
        }

        buildFilterObject() {
            this.filterParams = {
                name: {
                    displayText: "Name",
                    value: ""
                },
                interestArea: {
                    displayText: null,
                    value: ""
                },
                hostCampus: {
                    displayText: "Host Campus",
                    value: ""
                },
                minFee: {
                    displayText: null,
                    value: ""
                },
                maxFee: {
                    displayText: null,
                    value: ""
                },
                hasScholarship: {
                    displayText: "Has Scholarship",
                    value: null
                },
                gradeLevel: {
                    displayText: "Grade Level",
                    value: ""
                },
                overnight: {
                    displayText: "Overnight Program",
                    value: null
                },
                preK: {
                    displayText: "Pre-K",
                    value: null
                },
                elementarySchool: {
                    displayText: "K-5th",
                    value: null
                },
                middleSchool: {
                    displayText: "6th-8th",
                    value: null
                },
                highSchool: {
                    displayText: "9th-12th",
                    value: null
                },
                college: {
                    displayText: "College",
                    value: null
                },
                startDate: {
                    displayText: "Start Date",
                    value: null
                },
                endDate: {
                    displayText: "End Date",
                    value: null
                },
                deadline: {
                    displayText: "",
                    value: ""
                },
                timeFrame: {
                    displayText: "Time Frame",
                    value: ""
                },
                search: { displayText: null, radius: "25", zipCode: '' },
                feeRange: {
                    displayText: "Fee Range",
                    value: null
                }
            };
        }

        getAllPrograms() {
            var queryParams = { pageNumber: this.pageNumber, pageSize: this.pageSize };
            this.Restangular.one("StudentEnrichment/allPrograms").get(queryParams).then((results) => {
                this.searchResults = results;
                this.loaded = true;
                this.markers = this.createPins();
            }, (reason) => {
                this.logError(reason, reason, true);
            });
        }

        setFees() {
            if (this.feeRange == "") {
                this.filterParams.minFee = '';
                this.filterParams.maxFee = '';
            }
            if (this.feeRange == "0") {
                this.filterParams.maxFee = -1;
                this.filterParams.minFee = 0;
            }
            if (this.feeRange == "1") {
                this.filterParams.minFee = 1;
                this.filterParams.maxFee = 99;
            }
            if (this.feeRange == "2") {
                this.filterParams.minFee = 100;
                this.filterParams.maxFee = 299;
            }
            if (this.feeRange == "3") {
                this.filterParams.minFee = 300;
                this.filterParams.maxFee = 499;
            }
            if (this.feeRange == "4") {
                this.filterParams.minFee = 500;
                this.filterParams.maxFee = 999;
            }
            if (this.feeRange == "5") {
                this.filterParams.maxFee = null;
                this.filterParams.minFee = 1000;
            }
        }

        clear() {
            this.feeRange = "";
            this.startDate = null;
            this.endDate = null;
            this.deadline = null;
            this.buildFilterObject();
            this.selectedFilters = [];
            this.getAllPrograms();
        }

        clearFilter(filter) {
            if (filter.value) {
                filter.value = null;
            }

            if (filter.radius && filter.zipCode) {
                filter.zipCode = null;
            }
            
            this.searchPrograms();
        }

        searchPrograms() {
            //if (this.startDate != null)
            //    this.filterParams.startDate.value = this.startDate ? moment(this.startDate).toDate() : null;
            //if (this.endDate != null)
            //    this.filterParams.endDate.value = this.startDate ? moment(this.endDate).toDate() : null;
            //if(this.deadline != null)
            //    this.filterParams.deadline.value = this.deadline ? moment(this.deadline).toDate() : null;
            this.filterParams.interestArea.displayText = this.filterParams.interestArea.value;
            this.filterParams.timeFrame.displayText = this.filterParams.timeFrame.value;
            this.filterParams.deadline.displayText = "Deadline: " + moment(this.filterParams.deadline.value).format("MM/DD/YYYY");
            this.filterParams.startDate.displayText = "Start Date: " + moment(this.filterParams.startDate.value).format("MM/DD/YYYY");
            this.filterParams.endDate.displayText = "End Date: " + moment(this.filterParams.endDate.value).format("MM/DD/YYYY");
            this.filterParams.hostCampus.displayText = this.filterParams.hostCampus.value;
            this.filterParams.search.displayText = "Within " + this.filterParams.search.radius + " miles of " + this.filterParams.search.zipCode;
            this.filterParams.name.displayText = "Name: " + this.filterParams.name.value;

            this.filterParams.pageNumber = this.pageNumber;
            this.filterParams.pageSize = this.pageSize;
            this.Restangular.all("StudentEnrichment/filterPrograms").post(this.getParams()).then((results) => {
                this.searchResults = results;
                this.markers = this.createPins();
                this.loaded = true;
            }, (reason) => {
                this.logError(reason, reason, true);
            });
        }

        getParams() {
            var minFee, maxFee;
            if (this.filterParams.feeRange.value == "") {
                minFee = '';
                maxFee = '';
            }
            if (this.filterParams.feeRange.value == "0") {
                minFee = '';
                maxFee = -1;
            }
            if (this.filterParams.feeRange.value == "1") {
                minFee = 1;
                maxFee = 99;
            }
            if (this.filterParams.feeRange.value == "2") {
                minFee = 100;
                maxFee = 299;
            }
            if (this.filterParams.feeRange.value == "3") {
                minFee = 300;
                maxFee = 499;
            }
            if (this.filterParams.feeRange.value == "4") {
                minFee = 500;
                maxFee = 999;
            }
            if (this.filterParams.feeRange.value == "5") {
                maxFee = "";
                minFee = 1000;
            }

            return {
                name: this.filterParams.name.value,
                interestArea: this.filterParams.interestArea.value,
                hostCampus: this.filterParams.hostCampus.value,
                minFee: minFee,
                maxFee: maxFee,
                hasScholarship: this.filterParams.hasScholarship.value,
                overnight: this.filterParams.overnight.value,
                preK: this.filterParams.preK.value,
                elementarySchool: this.filterParams.elementarySchool.value,
                middleSchool: this.filterParams.middleSchool.value,
                highSchool: this.filterParams.highSchool.value,
                college: this.filterParams.college.value,
                startDate: this.filterParams.startDate.value ?  moment(this.filterParams.startDate.value).toDate() : '',
                endDate: this.filterParams.endDate.value ? moment(this.filterParams.endDate.value).toDate() : '',
                deadline: this.filterParams.deadline.value ? moment(this.filterParams.deadline.value).toDate() : '',
                timeFrame: this.filterParams.timeFrame.value,
                search: this.filterParams.search,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }
        }

        mapSingleProgram(program: any) {
            this.markers = this.createSinglePin(program);
        }

        createSinglePin(program: any) {
            var markers = [];
            var marker = {
                selected: false,
                latitude: program.latitude,
                longitude: program.longitude,
                id: program.id,
                options: {
                    optimized: false,
                    title: program.name,
                    icon: document.location.origin + "/images/blue_pin.png"

                },
                show: false
            };
            markers.push(marker);
            return markers;
        }

        resetPins() {
            this.markers = this.createPins();
        }

        createPins() {
            var markers = [];
            _.forEach(this.searchResults.enrichmentPrograms, function (p) {
                var marker = {
                    selected: false,
                    latitude: p.latitude,
                    longitude: p.longitude,
                    id: p.id,
                    options: {
                        optimized: false,
                        title: p.name,
                        icon: document.location.origin + "/images/blue_pin.png"

                    },
                    show: false
                };
                markers.push(marker);
            });
            return markers;
        }
        displayFilters(selectedFilters: any, filterName: string) {
            var found = _.indexOf(selectedFilters, filterName);
            if (found == -1) {
                this.selectedFilters.push(filterName);
            }
            else {
                selectedFilters.splice(found, 1);
            }
        }

        displayHostFilters(selectedFilters: any, filterName: string) {
            if (filterName != '' && this.oldHost == '') {
                this.oldHost = filterName;
                this.selectedFilters.push(filterName);
            }
            else if (filterName != '' && this.oldHost != '') {
                var found = _.indexOf(selectedFilters, this.oldHost);
                selectedFilters.splice(found, 1);
                this.selectedFilters.push(filterName);
                this.oldHost = filterName;
            }
            else {
                var found = _.indexOf(selectedFilters, filterName);
                selectedFilters.splice(found, 1);
                this.oldHost = '';
            }
        }

        displaySearchFilter(selectedFilters: any, filterName: string) {
            if (filterName != '' && this.oldSearch == '') {
                this.oldSearch = filterName;
                this.selectedFilters.push(filterName);
            }
            else if (filterName != '' && this.oldSearch != '') {
                var found = _.indexOf(selectedFilters, this.oldSearch);
                selectedFilters.splice(found, 1);
                this.selectedFilters.push(filterName);
                this.oldSearch = filterName;
            }
            else {
                var found = _.indexOf(selectedFilters, filterName);
                selectedFilters.splice(found, 1);
                this.oldSearch = '';
            }
        }

        displayDistanceFilters(selectedFilters: any, filterName: string) {
            if (filterName != '' && this.oldDistance == '' && this.filterParams.search.zipCode != '') {
                this.oldDistance = filterName;
                this.selectedFilters.push(filterName);
            }
            else if (this.filterParams.search.zipCode == '' || this.filterParams.search.zipCode == null || _.endsWith(filterName, 'of ') || _.endsWith(filterName, 'null')) {
                var found = _.indexOf(selectedFilters, this.oldDistance);
                selectedFilters.splice(found, 1);
                this.oldDistance = '';
            }
            else if (filterName != '' && this.oldDistance != '') {
                var found = _.indexOf(selectedFilters, this.oldDistance);
                selectedFilters.splice(found, 1);
                this.selectedFilters.push(filterName);
                this.oldDistance = filterName;
            }
        }

        buildImageUrl(baseUrl: string) {
            var test = _.startsWith(baseUrl, '/institutions') || _.startsWith(baseUrl, '/StudentEnrichment');
            return test ? this.apiHost + baseUrl : baseUrl;
        }
    }
    

    angular.module("app").controller(StudentEnrichment.controllerId, StudentEnrichment);

    var coords = [{ latitude: 33.7963, longitude: -78.4850 },
    { latitude: 34.8037, longitude: -79.6742 },
    { latitude: 34.8206, longitude: -80.8003 },
    { latitude: 34.9377, longitude: -80.7880 },
    { latitude: 35.1019, longitude: -80.9377 },
    { latitude: 35.0356, longitude: -81.0379 },
    { latitude: 35.1457, longitude: -81.0324 },
    { latitude: 35.1660, longitude: -81.3867 },
    { latitude: 35.1985, longitude: -82.2739 },
    { latitude: 35.2041, longitude: -82.3933 },
    { latitude: 35.0637, longitude: -82.7765 },
    { latitude: 35.0817, longitude: -82.7861 },
    { latitude: 34.9996, longitude: -83.1075 },
    { latitude: 34.9918, longitude: -83.6183 },
    { latitude: 34.9918, longitude: -84.3201 },
    { latitude: 35.2131, longitude: -84.2885 },
    { latitude: 35.2680, longitude: -84.2226 },
    { latitude: 35.2310, longitude: -84.1113 },
    { latitude: 35.2815, longitude: -84.0454 },
    { latitude: 35.4058, longitude: -84.0248 },
    { latitude: 35.4719, longitude: -83.9424 },
    { latitude: 35.5166, longitude: -83.8559 },
    { latitude: 35.5512, longitude: -83.6938 },
    { latitude: 35.5680, longitude: -83.5181 },
    { latitude: 35.6327, longitude: -83.3849 },
    { latitude: 35.7142, longitude: -83.2475 },
    { latitude: 35.7799, longitude: -82.9962 },
    { latitude: 35.8445, longitude: -82.9276 },
    { latitude: 35.9224, longitude: -82.8191 },
    { latitude: 35.9958, longitude: -82.7710 },
    { latitude: 36.0613, longitude: -82.6419 },
    { latitude: 35.9702, longitude: -82.6103 },
    { latitude: 35.9547, longitude: -82.5677 },
    { latitude: 36.0236, longitude: -82.4730 },
    { latitude: 36.0669, longitude: -82.4194 },
    { latitude: 36.1168, longitude: -82.3535 },
    { latitude: 36.1345, longitude: -82.2862 },
    { latitude: 36.1467, longitude: -82.1461 },
    { latitude: 36.1035, longitude: -82.1228 },
    { latitude: 36.1268, longitude: -82.0267 },
    { latitude: 36.2797, longitude: -81.9360 },
    { latitude: 36.3527, longitude: -81.7987 },
    { latitude: 36.3361, longitude: -81.7081 },
    { latitude: 36.5880, longitude: -81.6724 },
    { latitude: 36.5659, longitude: -80.7234 },
    { latitude: 36.5438, longitude: -80.2977 },
    { latitude: 36.5449, longitude: -79.6729 },
    { latitude: 36.5449, longitude: -77.2559 },
    { latitude: 36.5505, longitude: -75.7562 },
    { latitude: 36.3129, longitude: -75.7068 },
    { latitude: 35.7131, longitude: -75.4129 },
    { latitude: 35.2041, longitude: -75.4720 },
    { latitude: 34.9794, longitude: -76.0748 },
    { latitude: 34.5258, longitude: -76.4951 },
    { latitude: 34.5880, longitude: -76.8109 },
    { latitude: 34.5314, longitude: -77.1378 },
    { latitude: 34.3910, longitude: -77.4481 },
    { latitude: 34.0481, longitude: -77.7983 },
    { latitude: 33.7666, longitude: -77.9260 },
    { latitude: 33.7963, longitude: -78.4863 }];
} 